import { Link, useNavigate } from "react-router-dom";
import React from "react";
import { LeagueAvatar } from "./LeagueAvatar";

function SwitchBlock({ leagues }) {
  const navigate = useNavigate();

  const handleSwitchLeague = (league) => {
    if (!league?.slug) return;
    navigate(`/${league.slug}/table`);
  };

  const sortedItems = [...(leagues ?? [])].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  const switchItems = sortedItems?.map((item, index) => {
    return (
      <div key={item._id} className="info-row">
        <div className="league-list-row">
          <div className="col">{index + 1}</div>
          <div className="col title">
            <div className="image">
              <LeagueAvatar image={item.image} name={item.name} />
            </div>
            <Link to={`/${item.slug}/table`}>{item.name}</Link>
          </div>
          <div className="col">{item.teams?.length ?? 0}</div>
          <div className="col">{item.seasonsPlayed ?? 0}</div>
          <div className="col league-link-col">
            <Link to={`/${item.slug}/table`} className="ico icon-tip league-link" />
          </div>
        </div>
        <div className="col">
          <button
            onClick={() => handleSwitchLeague(item)}
            className="submit-btn"
          >
            SWITCH
          </button>
        </div>
      </div>
    );
  });

  return (
    <div className="leagues-container">
      <div className="header-row league-list-row">
        <div className="info-col">League name</div>
        <div className="info-col">Teams</div>
        <div className="info-col">Seasons</div>
      </div>
      {switchItems}
    </div>
  );
}

export { SwitchBlock };
